import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useStateIfMounted } from 'use-state-if-mounted';
import {
    actualizarFC_40PaginaActiva, obtenerContadorDeFechaFolio,
    ObtenerClientePorLogin40,
    actualizarFC_40Estatus,
    agregarFC_40Accion,
    resetDataFC_40, actualizarFC_40Solicitud
} from '../../../redux/DucksBeneficiario/FC_40Ducks';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter, Link, NavLink } from 'react-router-dom';
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
const { useState, useEffect, useRef } = React;
import estilos from './FormularioFC40BeneficiarioComponent.module.css';

import InfoBar from '../../App/InfoBar'
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';
import { Formik } from 'formik'
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import DocumentacionFC_40Component from './DocumentacionFC_40Component';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function FormularioFC40BeneficiarioComponent(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)

    let fc_40 = useSelector(store => store.FC_40Solicitud.fc_40)
    let fc_40Map = useSelector(store => store.FC_40Solicitud.fc_40Map)
    const modoEdicionBorrador = useSelector(store => store.FC_40Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_40Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_40Solicitud.data)
    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    const currentUser = useSelector(store => store.Usuario.data)

    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])

    let dataLogin = useSelector(store => store.FC_40Solicitud.dataLogin)
    let dataCliente = useSelector(store => store.FC_40Solicitud.cliente)
    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin40({ idlogin: usuario.data.user[0].id }))
    }, [])
    var fechaHoy = moment().format('YYYY-MM-DD');

    const idUsuario = usuario.data.user[0].id

    const [fechasolicitud, setfechasolicitud] = useStateIfMounted(fechaHoy)
    const [numerocliente, setnumerocliente] = useStateIfMounted(0)
    const [nombrerazonsocial, setnombrerazonsocial] = useStateIfMounted('')
    const [telefono, settelefono] = useStateIfMounted('')
    const [correoelectronico, setcorreoelectronico] = useStateIfMounted('')
    const [hologramasparamezcal, sethologramasparamezcal] = useStateIfMounted(false)
    const [cantidadhologramasparamezcal, setcantidadhologramasparamezcal] = useStateIfMounted(0)
    const [hologramasparabebidasconmezcal, sethologramasparabebidasconmezcal] = useStateIfMounted(false)
    const [cantidadhologramasparabebidasco, setcantidadhologramasparabebidasco] = useStateIfMounted(0)
    const [idfc40_solicitudadquisicionholo, setidfc40_solicitudadquisicionholo] = useStateIfMounted(0)
    const idestatusdesolicitudes = 2
    const idlogin = idUsuario

    /*Controlar las el formulario con las paginas*/
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const paginaActiva = useSelector(store => store.FC_40Solicitud.paginaActiva)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Documentación'])
    const paginaSiguiente = async (valores) => {
        const result = await validation(valores)
        if (JSON.stringify(result) !== '{}') {
            settexto('')
            setvalidacion(true)
        } else {
            dispatch(actualizarFC_40PaginaActiva(paginaActiva + 1))
        }
    }
    const paginaAnterior = async () => {
        dispatch(actualizarFC_40PaginaActiva(paginaActiva - 1))
    }
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    const actualizarHologramasMezcal = () => {
        if (!hologramasparamezcal) sethologramasparamezcal(true)
        else sethologramasparamezcal(false)
    }
    const actualizarHologramasBebidas = () => {
        if (!hologramasparabebidasconmezcal) sethologramasparabebidasconmezcal(true)
        else sethologramasparabebidasconmezcal(false)
    }

    const store = useSelector(store => store)

    const noActualizarBorrador = useRef(true)
    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_40 = data
        }
    }, [fc_40, data])


    const [modoEdicionBorradorState, setModoEdicionBorradorState] = useStateIfMounted(modoEdicionBorrador)
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()


    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')

    const handleOpenModal = (data) => {

        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} component="h2">
                            {bodyModal} <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'enviarSolicitudFC_40':
                                        activarBotonEnviarForm()
                                        functionSubmitForm.function()
                                        break;
                                    case 'guardarBorrador':
                                        guardarBorrador(dataModal)
                                        break;
                                    case 'actualizarBorrador':
                                        actualizarBorrador(dataModal)
                                        break;
                                    case 'enviarSolicitudBorradorFC_40':
                                        activarBotonEnviarBorrador()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarCorreccion':
                                        activarBotonEnviarCorreciones()
                                        functionSubmitForm.function()
                                        break;
                                    case 'reiniciarFormato':
                                        handleResetAllPropertys()
                                        functionResetForm.function()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const handleResetAllPropertys = () => {
        handleCloseModal()
        dispatch(resetDataFC_40())
    }
    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const botonEnviarSolicitudFC_40 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atencion al cliente.`,
            accion: 'enviarSolicitudFC_40'
        })
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores.
                Los archivos de la sección final no se guardarán puesto que es un borrador del formulario.`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonEnviarSolicitudBorradorFC_40 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_40'
        })
    }
    const botonEnviarCorreccionesFC_40 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atencion al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }
    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonRegistrarFC_40 = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        let telefono = valores.telefono + ''
        let cantidadmezcal = valores.cantidadmezcal + ''
        let cantidadbebidasmezcal = valores.cantidadbebidasmezcal + ''
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            telefono: telefono, correoelectronico: valores.correoelectronico, hologramasmezcal: valores.hologramasmezcal,
            cantidadmezcal: cantidadmezcal, hologramasbebidasmezcal: valores.hologramasbebidasmezcal,
            cantidadbebidasmezcal: cantidadbebidasmezcal,
            idestatusdesolicitudes: 7, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }

        const resultado = await dispatch(agregarFC_40Accion(solicitud))
        await dispatch(actualizarLoadingApp_false())

        if (resultado) {
            await dispatch(resetDataFC_40())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio
        let telefono = valores.telefono + ''
        let cantidadmezcal = valores.cantidadmezcal + ''
        let cantidadbebidasmezcal = valores.cantidadbebidasmezcal + ''
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            telefono: telefono, correoelectronico: valores.correoelectronico, hologramasmezcal: valores.hologramasmezcal,
            cantidadmezcal: cantidadmezcal, hologramasbebidasmezcal: valores.hologramasbebidasmezcal,
            cantidadbebidasmezcal: cantidadbebidasmezcal,
            idestatusdesolicitudes: 1, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }

        const resultado = await dispatch(agregarFC_40Accion(solicitud))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_40())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let telefono = valores.telefono + ''
        let cantidadmezcal = valores.cantidadmezcal + ''
        let cantidadbebidasmezcal = valores.cantidadbebidasmezcal + ''
        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc40_solicitudadquisicionholo: data.idfc40_solicitudadquisicionholo,
            telefono: telefono, correoelectronico: valores.correoelectronico, hologramasmezcal: valores.hologramasmezcal,
            cantidadmezcal: cantidadmezcal, hologramasbebidasmezcal: valores.hologramasbebidasmezcal,
            cantidadbebidasmezcal: cantidadbebidasmezcal,
            idestatusdesolicitudes: 1,
        }
        const resultado = await dispatch(actualizarFC_40Solicitud(solicitud))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_40())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let telefono = valores.telefono + ''
        let cantidadmezcal = valores.cantidadmezcal + ''
        let cantidadbebidasmezcal = valores.cantidadbebidasmezcal + ''
        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc40_solicitudadquisicionholo: data.idfc40_solicitudadquisicionholo,
            telefono: telefono, correoelectronico: valores.correoelectronico, hologramasmezcal: valores.hologramasmezcal,
            cantidadmezcal: cantidadmezcal, hologramasbebidasmezcal: valores.hologramasbebidasmezcal,
            cantidadbebidasmezcal: cantidadbebidasmezcal,
            idestatusdesolicitudes: 7,
        }
        const resultado = await dispatch(actualizarFC_40Solicitud(solicitud))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc40_solicitudadquisicionholo
            const estatusNuevo = 7
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_40 = 11
            const tabla = tablaFC_40
            await dispatch(actualizarFC_40Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_40())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy)?.toISOString()
        let telefono = valores.telefono + ''
        let cantidadmezcal = valores.cantidadmezcal + ''
        let cantidadbebidasmezcal = valores.cantidadbebidasmezcal + ''
        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc40_solicitudadquisicionholo: data.idfc40_solicitudadquisicionholo,
            telefono: telefono, correoelectronico: valores.correoelectronico, hologramasmezcal: valores.hologramasmezcal,
            cantidadmezcal: cantidadmezcal, hologramasbebidasmezcal: valores.hologramasbebidasmezcal,
            cantidadbebidasmezcal: cantidadbebidasmezcal,
            idestatusdesolicitudes: 6,
        }

        const resultado = await dispatch(actualizarFC_40Solicitud(solicitud))
        const idSolicitud = data.idfc40_solicitudadquisicionholo
        const estatusNuevo = 6
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_40 = 11
        const tabla = tablaFC_40
        await dispatch(actualizarFC_40Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_40())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')
    }
    const validation = values => {
        let errores = {};
        const textoCheck = 'Debe de seleccionar al menos una opción'
        const texto = 'Campo Obligatorio'
        if (paginaActiva === 1) {
            if (!values.correoelectronico) { errores.correoelectronico = texto }
            if (!values.telefono) { errores.telefono = texto }
            if (!values.hologramasmezcal && !values.hologramasbebidasmezcal) {
                errores.hologramasmezcal = textoCheck
            }
            if (values.hologramasmezcal) {
                if (!values.cantidadmezcal) { errores.cantidadmezcal = texto }
            }
            if (values.hologramasbebidasmezcal) {
                if (!values.cantidadbebidasmezcal) { errores.cantidadbebidasmezcal = texto }
            }
        }
        return errores;
    }

    const [openModalMensaje, setOpenModalMensaje] = React.useState(false);
    const handleCloseModalMensaje = () => {
        setOpenModalMensaje(false)
    }
    const modalComponentMensaje = () => {
        return (
            <div>
                <Modal
                    open={openModalMensaje}
                    onClose={handleCloseModalMensaje}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>Mensaje</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'justify' }} component="h2">
                            Si deseas comprar hologramas de certificación, es importante ampliar cadena
                            productiva como {dataCliente.comercializadordemezcal && 'Comercializador de Mezcal '}
                            {(dataCliente.comercializadordemezcal && dataCliente.comercializadordebebidasconmezcal) && 'o'}
                            {dataCliente.comercializadordebebidasconmezcal && 'Comercializador de Bebidas con Mezcal '} a través de
                            una solicitud de actualización. <br />
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => { handleCloseModalMensaje() }}>Aceptar</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <Formik
                initialValues={
                    fc_40
                }
                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_40(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                }}>
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2'>
                            <div className='row mt-3'>
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-12 marginsitoTop">
                                    <InfoBar nombreSolicitud={'Solicitud de compra de hologramas'} />
                                </div>
                                {!modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center marginsitoTop">
                                        <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                            aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                botonGuardarComoBorrador(values)}
                                        >
                                            <SaveIcon />
                                            {modoEdicionBorrador ? (
                                                <div className="badge text-dark textoNormal textoModal">
                                                    Guardar cambios en borrador
                                                </div>) : (
                                                <div className="badge text-dark textoNormal textoModal">
                                                    Guardar como borrador
                                                </div>
                                            )
                                            }
                                        </IconButton>
                                    </div>
                                }
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center marginsitoTop">
                                    <h1></h1>
                                </div>
                                {
                                    !modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1 text-center marginsitoTop">
                                        <Fragment>
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() => { botonReiniciarFormato(), setFunctionResetForm({ function: resetForm }) }}
                                            >
                                                <FormatClearIcon />
                                                <div className="badge text-dark textoNormalbadge text-dark textoModal text-center">Reiniciar Formato </div>
                                            </IconButton>
                                        </Fragment>
                                    </div>
                                }
                            </div>
                            {paginaActiva === 1 ?
                                (<Fragment>
                                    <div className='row'>
                                        <h4 className={`text-center ${estilos.labelNaranja}`}>Información del solicitante</h4>
                                    </div>
                                    <div className='row justify-content-start'>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_40Map.correoelectronicocheck !== undefined ? (
                                                    fc_40Map?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='correoelectronico'
                                                    name="correoelectronico"
                                                    value={values.correoelectronico}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Correo electrónico</label>
                                                <span className='text-danger'>{fc_40Map?.correoelectronicocheck ? fc_40Map?.correoelectronico : ''}</span>
                                                {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-3">
                                                <input type="number" className={`form-control ${fc_40Map.telefonocheck !== undefined ? (
                                                    fc_40Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='telefono'
                                                    name="telefono"
                                                    value={values.telefono}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Teléfono</label>
                                                {<span className='text-danger'>{fc_40Map?.telefonocheck ? fc_40Map?.telefono : ''}</span>}
                                                {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                            </div>
                                        </div>
                                    </div> <br />
                                    <div className='row'>
                                        <h4 className={`text-center ${estilos.labelNaranja}`}>Servicio solicitado</h4>
                                    </div>
                                    <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                        <div className='col-md-12 text-center'>
                                            <b>ADQUISICIÓN DE HOLOGRAMAS DE CERTIFICACIÓN</b>
                                        </div>
                                        <div className='col-md-7 text-center'>
                                            TIPO DE HOLOGRAMAS
                                        </div>
                                        {hologramasparabebidasconmezcal || hologramasparamezcal ?
                                            <div className='col-md-5 '>
                                                CANTIDAD DE HOLOGRAMAS SOLICITADOS
                                            </div> : ''
                                        }
                                        <div className='col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 mt-2 text-start'>
                                            <input className={`form-check-input me-1 ${fc_40Map.hologramasmezcalcheck !== undefined ? (
                                                fc_40Map?.hologramasmezcalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                checked={values.hologramasmezcal} id='hologramasmezcal'
                                                name="hologramasmezcal"
                                                onChange={e => {
                                                    if (dataCliente.comercializadordemezcal == true) {
                                                        const { ...newValues } = values
                                                        newValues.hologramasmezcal = e.target.checked
                                                        setValues(newValues)
                                                    } else {
                                                        setOpenModalMensaje(true)
                                                        const { ...newValues } = values
                                                        newValues.hologramasmezcal = e.target.checked
                                                        setValues(newValues)
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                Hologramas para mezcal
                                            </label><br />
                                            <span className='text-danger'>{fc_40Map?.hologramasmezcalcheck ? fc_40Map?.hologramasmezcal : ''}</span>
                                        </div>

                                        {values.hologramasmezcal ?
                                            <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                <div className="form-floating mb-3">
                                                    <input type="number" className={`form-control ${fc_40Map.cantidadmezcalcheck !== undefined ? (
                                                        fc_40Map?.cantidadmezcalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        id="" placeholder='cantidadmezcal'
                                                        name="cantidadmezcal"
                                                        value={values.cantidadmezcal}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onWheel={event => event.currentTarget.blur()}
                                                    />
                                                    <label htmlFor='floatingInput'>Cantidad para mezcal</label>
                                                    <span className='text-danger'>{fc_40Map?.cantidadmezcalcheck ? fc_40Map?.cantidadmezcal : ''}</span>
                                                    {errors.cantidadmezcal && <div className="text-danger">{errors.cantidadmezcal}</div>}
                                                </div>
                                            </div> : ''
                                        }
                                        <div className='col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 mt-2 text-start'>
                                            <input className={`form-check-input me-1 ${fc_40Map.hologramasbebidasmezcalcheck !== undefined ? (
                                                fc_40Map?.hologramasbebidasmezcalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                checked={values.hologramasbebidasmezcal} id='hologramasbebidasmezcal'
                                                name="hologramasbebidasmezcal"
                                                onChange={e => {
                                                    
                                                    if (dataCliente.comercializadordebebidasconmezcal == true) {
                                                        const { ...newValues } = values
                                                    newValues.hologramasbebidasmezcal = e.target.checked
                                                    setValues(newValues)
                                                    } else {
                                                        setOpenModalMensaje(true)
                                                        const { ...newValues } = values
                                                    newValues.hologramasbebidasmezcal = e.target.checked
                                                    setValues(newValues)
                                                    }
                                                }}

                                                onBlur={handleBlur}
                                            />
                                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                Hologramas para bebidas con mezcal
                                            </label><br />
                                            <span className='text-danger'>{fc_40Map?.hologramasbebidasmezcalcheck ? fc_40Map?.hologramasbebidasmezcal : ''}</span>
                                        </div>
                                        {values.hologramasbebidasmezcal ?
                                            <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                <div className="form-floating mb-3">
                                                    <input type="number" className={`form-control ${fc_40Map.cantidadbebidasmezcalcheck !== undefined ? (
                                                        fc_40Map?.cantidadbebidasmezcalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        id="" placeholder='cantidadbebidasmezcal'
                                                        name="cantidadbebidasmezcal"
                                                        value={values.cantidadbebidasmezcal}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onWheel={event => event.currentTarget.blur()}
                                                    />
                                                    <label htmlFor='floatingInput'>Cantidad para bebidas con mezcal</label>
                                                    <span className='text-danger'>{fc_40Map?.cantidadbebidasmezcalcheck ? fc_40Map?.cantidadbebidasmezcal : ''}</span>
                                                    {errors.cantidadbebidasmezcal && <div className="text-danger">{errors.cantidadbebidasmezcal}</div>}
                                                </div>
                                            </div> : ''
                                        }
                                        {errors.hologramasmezcal && <div className="text-danger">{errors.hologramasmezcal}</div>}

                                    </div>
                                    <br />
                                    <div className='row' >
                                        <h4 className={`text-center ${estilos.labelNaranja}`}>Notas</h4>
                                    </div>
                                    <div className='row justify-content-start' style={{ textAlign: 'justify' }}>
                                        <p>
                                            <b>
                                                LA ENTREGA DE HOLOGRAMAS PROCEDERÁ ÚNICAMENTE EN LOS SIGUIENTES CASOS
                                            </b>
                                        </p>
                                        <div>
                                            <ol type='a' >
                                                <li>
                                                    <b>Cuando el muestreo se haya realizado en producto a granel:</b>
                                                    <ul>
                                                        <li>El producto a granel deberá contar con Certificado NOM de Mezcal a granel vigente.</li>
                                                        <li>Solo se entregarán los hologramas que se justifiquen con el volumen del lote y la cantidad
                                                            y presentación de las botellas a envasar.
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <b>Cuando el muestreo se vaya a realizar en producto envasado</b>
                                                    <ul>
                                                        <li>El producto deberá encontrarse en los registros de la Unidad de Inspección.</li>
                                                        <li>Deberá haberse mostrado ante la Unidad de inspección que el producto cuenta con trazabilidad
                                                            y es auténtico.
                                                        </li>
                                                        <li>Solo se entregarán los hologramas que se justifiquen con el volumen del lote y la cantidad y
                                                            presentación de las botellas a envasar.
                                                        </li>
                                                        <li>
                                                            El Certificado NOM de Mezcal a granel se emitirá hasta comprobarse el cumplimiento con el apartado 4.3 de
                                                            la NOM-070-SCFI-2016 mediante el análisis de laboratorio.
                                                        </li>
                                                        <li>
                                                            En caso de incumplimiento con el apartado 4.3. de la NOM-070-SCFI-2016, el solicitante deberá realizar
                                                            las acciones pertinentes para reacondicionar el lote. No se emitirán los Certificados NOM de Mezcal a
                                                            granel y en consecuencia los Certificados NOM para Venta Nacional y para exportación hasta demostrarse
                                                            la conformidad con la NOM-070-SCFI-2016.
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ol>
                                        </div>
                                        <br />
                                    </div><br />

                                </Fragment>
                                ) : (
                                    <Fragment>
                                        {
                                            modoCorreccion &&
                                            <div className={`row col-md-12`} style={{ marginLeft: '-9%' }}>
                                                <DocumentacionFC_40Component />
                                            </div>
                                        }
                                        <div className=" text-align: justify">
                                            <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_40'} />
                                        </div> <br /> <br />
                                        <div className="row mt-4">
                                            {!modoCorreccion ?
                                                <div>
                                                    <div className="row mt-4">
                                                        {
                                                            modoEdicionBorrador ? (
                                                                <div className="d-grid gap-2 col-2 mx-auto">
                                                                    <button type="submit"
                                                                        onClick={() => { botonEnviarSolicitudBorradorFC_40(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                        className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                        disabled={!terminosYCondiciones}>Enviar borrador</button>
                                                                </div>
                                                            ) : (
                                                                <div className="d-grid gap-2 col-2 mx-auto">
                                                                    <button type="submit"
                                                                        onClick={() => { botonEnviarSolicitudFC_40(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                        className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                        disabled={!terminosYCondiciones}>Enviar</button>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                :
                                                <div className="row mt-4">
                                                    <div className="d-grid gap-2 col-2 mx-auto">
                                                        <button type="submit"
                                                            onClick={() => { botonEnviarCorreccionesFC_40(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                            className={`btn ${estilos.botonNaranjaRedondo}`}
                                                            disabled={!terminosYCondiciones}>Enviar correcciones</button>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </Fragment>
                                )
                            }<br />
                            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                            <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                            {modalComponent()}
                            {modalComponentMensaje()}
                        </div>
                    </form>
                )}
            </Formik>
        </Fragment>
    )
}

export default withRouter(FormularioFC40BeneficiarioComponent)
